var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 32,
    viewBox: "0 0 90 32",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.61779 19.948H0V13.4076H4.36411V3.72493C4.36411 2.85859 4.70639 2.02773 5.31567 1.41513C5.92494 0.802535 6.7513 0.458382 7.61294 0.458382H29.528V6.99148H10.8594V16.6814C10.8594 17.5465 10.5181 18.3763 9.91036 18.9887C9.30266 19.601 8.47817 19.946 7.61779 19.948Z",
    fill: "#004E5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.88 0H38.3823V18.9557H44.88V0Z",
    fill: "#004E5E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1387 12.4885H67.641V32H74.1387V12.4885Z",
    fill: "#004E5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90 18.951H83.5023V6.99148H54.4907V0.458382H86.7512C87.6128 0.458382 88.4392 0.802535 89.0485 1.41513C89.6577 2.02773 90 2.85859 90 3.72493V18.951Z",
    fill: "#004E5E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5455 31.0834H26.0633C25.2016 31.0834 24.3753 30.7393 23.766 30.1267C23.1567 29.5141 22.8145 28.6832 22.8145 27.8169V12.4885H29.3121V24.5503H54.3088V12.4885H60.8064V27.8169C60.8064 28.2469 60.722 28.6726 60.558 29.0698C60.3939 29.4669 60.1535 29.8275 59.8506 30.131C59.5476 30.4345 59.188 30.6748 58.7925 30.8383C58.3969 31.0017 57.9731 31.085 57.5455 31.0834Z",
    fill: "#004E5E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logoSmall.fb9911308c1cb74ac3b77360d6cba433.svg";
export { ForwardRef as ReactComponent };